import type { ReactNode } from 'react';
import type { InterviewPanelView } from '@nest-recruit/shared';
import { Avatar } from '../../../components/Avatar';
import { panelPills } from './panel-pills';
import styles from './contact.module.css';

/** PLN-01's Interviewer(s) (Job-contact.dc.html "planner"): one pill per person, the lead first and tagged. */
export function PanelPills({ panel }: { readonly panel: readonly InterviewPanelView[] }): ReactNode {
  const { shown, more } = panelPills(panel);
  const hidden = panel.length > shown.length ? panel.filter((member) => !shown.includes(member)) : [];
  return (
    <span className={styles.pills}>
      {shown.map((member) => (
        <span key={member.userId} className={styles.pill}>
          <Avatar name={member.fullName} size="sm" />
          <span className={styles.pillName}>{member.fullName}</span>
          {member.role === 'lead' && <span className={styles.pillLead}>Lead</span>}
        </span>
      ))}
      {more > 0 && (
        <span className={styles.pill} title={hidden.map((member) => member.fullName).join(', ')}>
          +{more}
        </span>
      )}
    </span>
  );
}
